import React from 'react';
import { FormattedMessage } from 'react-intl';
import browserHistory from 'react-router/lib/browserHistory';
import CSSModules from 'react-css-modules';
import Button from '../Button';
import { AUTH } from '../../constants/strings';
import { LOGIN } from '../../constants/routes';
import styles from './index.styl';
import MetaHelmet from '../AppHelmet/MetaHelmet';
import { usePageView } from '../../hocs/usePageView';

const ExpiredToken = () => {
  usePageView('Expired Token');
  return (
    <div styleName="formWrapper">
      <MetaHelmet title="pages.title.expiredToken" />

      <p styleName="formTitle">
        <FormattedMessage {...AUTH.titles.expiredToken} />
      </p>
      <p styleName="formText" className="mb4">
        <FormattedMessage {...AUTH.actions.expiredToken.textTitle} />
      </p>
      <Button
        className="db w-100"
        color="primary"
        raised
        onClick={() => browserHistory.push(LOGIN)}
      >
        <FormattedMessage {...AUTH.submit.expiredToken} />
      </Button>
    </div>
  );
};

export default CSSModules(ExpiredToken, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/Auth/ExpiredToken.jsx